import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { ConfirmRowAction } from '@dfl/mui-admin-layout';
import { useTranslation } from 'react-i18next';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { useRemoveDispatchSubOrder } from '../../hooks/useRemoveDispatchSubOrder';
import { RemoveCircle } from '@mui/icons-material';

type UserStatusProps = {
  rowId: string;
  record: IOrder;
};

const DispatchSubOrderRowActions = ({ rowId, record }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const { t } = useTranslation('dispatch');
  const { mutate, isPending, error } = useRemoveDispatchSubOrder(record?.dispatch as string, rowId, onClose);
  return (
    <>
      <Stack direction='row' spacing={1}>
        <ConfirmRowAction
          tooltip={t('orderRemove')}
          isOpen={isOpen}
          icon={<RemoveCircle color='error' />}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onConfirm={mutate}
          confirmationMessage={t('confirmationDeleteSubOrder')}
        />
      </Stack>
    </>
  );
};

export default memo(DispatchSubOrderRowActions);
